:host {
    /* Success page */

    font-family: "Fira Sans", sans-serif;

    h4 {
        font-size: 2.6rem;
    }

    position: relative;
   
    .offline-steps {
        max-width: 650px;
    }

    c-format-string {
        display: block;
        font-weight: bold;
        margin-bottom: 80px;
        font-size: 2.2rem;
    }

    p.hint {
        padding-top: 7px;
        border-left: 7px solid #346799;
        padding-left: 20px;
        margin-bottom: 40px;
    }

    p.hint + c-button {
        margin-bottom: 40px;
    }
 
    c-header {
        clear: both;
    }

    p {
        font-size: 1.8rem;
        line-height: 1.5555555556;
        padding-bottom: 10px;
    }

    .download {
        float: left;
        a {
            color: #0a171f;

            c-icon {
                color: #0a171f;
                width: 40px;
                height: 40px;
            }
        }
    }

    a.link {
        float: right;
        font-size: 1.8rem;
        font-style: italic;
        text-decoration: none;
        padding: 16px 4px 0 0;
        line-height: 1.3333333333;
        border-bottom: 1px solid #0a171f;

        &:hover {
            border-bottom-color: transparent;
        }
    }

    c-button.right {
        float: right;
    }

    ol {
        padding-left: 32px;

        li {
            counter-increment: step-counter;
            position: relative;

            &::before {
                content: counter(step-counter);
                background-color: #346799;
                color: white;
                font-weight: bold;
                font-size: 16px;
                width: 22px;
                padding: 5px 5px 6px;
                border-radius: 2px;
                text-align: center;
                position: absolute;
                left: -30px;
            }

            h5 {
                padding: 5px 5px 6px 16px;
                font-weight: bold;
                font-size: 1.65rem;
                background-color: #f0f4f7;
            }
            c-markdown-renderer {
                margin-left: 16px;
            }

            .download-button {
                all: unset;
                margin-left: 16px;
                margin-top: 10px;
                display: block;
                margin-bottom: 40px;
                background-color: #346799;
                color: white;
                font-weight: normal;
                font-size: 16px;
                padding: 5px 32px 6px;
                border-radius: 2px;
                text-align: center;
                cursor: pointer;
            }
        }
    }

    .confirm-buttons {
        margin-top: 30px;
    }

}

